<template>
  <v-overlay :color="'#fff'" :value="loading" z-index="10" opacity="1">
    <div class="overlay-content">
      <span class="loader-text">
        {{ $t("settings.billing.billing_method.adding_method") }}
      </span>
      <v-progress-linear
        :value="progress"
        color="primary"
        background-color="element-bg-300"
        height="6"
        rounded></v-progress-linear>
    </div>
  </v-overlay>
</template>

<script>
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    data() {
      return {
        response: this.$route.query,
        loading: false,
        progress: 0,
        stripe: null,
        intent: null,
        intentType: null,
        subscription: this.$route.query?.subscription,
      };
    },
    beforeMount() {
      this.displayLoader();
      this.handleBillingMethod();
    },
    methods: {
      async handleBillingMethod() {
        this.stripe = await this.$store.dispatch("billing/getStripe");
        this.intentType = this.response?.setup_intent ? "setup" : "payment";
        const retrieveIntent =
          this.intentType === "setup" ? this.stripe.retrieveSetupIntent : this.stripe.retrievePaymentIntent;

        const clientSecret =
          this.intentType === "setup"
            ? this.response.setup_intent_client_secret
            : this.response.payment_intent_client_secret;

        const response = await retrieveIntent(clientSecret);
        this.intent = this.intentType === "setup" ? response.setupIntent : response.paymentIntent;

        switch (this.intent.status) {
          case "succeeded":
            await this.completeBillingMethod();
            this.$router.push({
              name: "settings",
              query: { tab: "billing_payments", response: "billing_method_success" },
            });
            break;
          case "requires_payment_method":
            this.$router.push({
              name: "settings",
              query: { tab: "billing_payments", response: "billing_method_failed_invalid" },
            });
            break;
          default:
            this.$router.push({
              name: "settings",
              query: { tab: "billing_payments", response: "billing_method_failed_generic" },
            });
            break;
        }
      },
      async completeBillingMethod() {
        try {
          await this.$admin.dataProvider.customHttpCall(
            "POST",
            `subscriptions/${this.subscription}/payment_methods/confirm`,
            {
              setupIntentId: this.intent.id,
            },
          );
        } catch (e) {
          this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
        }
      },
      displayLoader() {
        this.loading = true;
        /**
         * Simulated, non-linear loading. Loads as long as possible, slowing down the further it gets.
         */
        this.interval = setInterval(() => {
          const increment = (100 - this.progress) / 10;
          if (this.progress < 95) {
            this.progress += increment;
          } else {
            this.progress += 0.05;
          }
          if (this.progress > 99.5) {
            this.progress = 99.5;
          }
        }, 250);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .overlay-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 320px;

    .loader-text {
      color: get-color("subtitle");
      @include text-body-2();
      margin-bottom: 16px;
    }
  }
</style>
